export const UNASSIGNED_OPTION = {
  avatar: 'assets/images/placeholders/avatar.jpg',
  label: 'Unassigned',
  value: 0,
}
